export const CBO_OCUPACAO_CSV_URL =
  'https://www.gov.br/trabalho-e-emprego/pt-br/assuntos/cbo/servicos/downloads/cbo2002-ocupacao.csv';

export const CBO_GOLDEN_ANALISTA_SISTEMAS = '212405';
export const CBO_GOLDEN_OFICIAL_AERONAUTICA = '010105';
export const CBO_MIN_OCUPACOES = 2400;
export const CBO_MAX_OCUPACOES = 2800;
